import React, { useEffect, useMemo, useState } from "react";
import AdminHeading from "../AdminPanel/Heading/AdminHeading";
import AdminBreadCrump from "../AdminPanel/Heading/AdminBreadCrump";
import style from "./AddSkuNew.module.css";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import GetApiService from "Components/Api/getapiService";
import { fetchSKUList } from "services/skus";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import CustomerTable from "Components/support/customervendor/customer";
import { SkuListColumn } from "utils/helpers";

const SkuListNew = () => {
  const navigate = useNavigate();
  const [searchInput, setSearchInput] = useState("");

  const allStates = useSelector((state) => state);
  const adminLoggedIn = allStates.reducer1;
  //   let Entryby_Staff_id = parseInt(adminLoggedIn);
  const clientCode = adminLoggedIn.ClientCode;
  const apiService = new GetApiService(clientCode);
  const {
    data: SKUList,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["SKU/SKUList", clientCode],
    queryFn: fetchSKUList,
    refetchOnWindowFocus: false,
    // cacheTime: 1000 * 60 * 2,
    // staleTime: 1000 * 60 * 2,
  });

 const skuList = useMemo(()=>{
    const formattedData = SKUList?.length ? SKUList.map((item, index) => ({
      // serialNumber: index + 1,  // If you need a sequential ID
      ...item,
      StockKeepingUnit: item.StockKeepingUnit,
      Vendor: item.SKUVendor.map(vendor => vendor.VendorName).join(", "), // Extract and join vendor names
      CategoryName: item.CategoryName,
      ProductName: item.ProductName,
      DesignName: item.DesignName,
      PurityName: item.PurityName,
      Description: item.Description
    })) : [];
    return formattedData
  },[SKUList])


  const handleSearchChange = (event) => {
    setSearchInput(event.target.value);
  };
  const handleSearchSubmit = () => {
    // You can handle the search logic here
    console.log("Searching for:", searchTerm);
  };

  return (
    <div>
      <AdminHeading />
      <div className="adminMainBodyBox" id="addBulkProductsBoxTop">
        <AdminBreadCrump
          title={"SKU List"}
          companyName={"Loyalstring"}
          module={"Masters"}
          page={"SKU List"}
        />

        <div className={style.adminAddCategoryMainBox}>
          <div className={style.adminAddCategoryInnerBox}>
            <div className={style.adminCategoryAddCategoryMainBox}>
              <div className={style["white-space"]}>
                <div
                  className={style["icon-div"]}
                  style={{ display: "flex", gap: "10px" }}
                >
                  <div
                    className={style["search-container"]}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <input
                      type="text"
                      value={searchInput}
                      onChange={handleSearchChange}
                      placeholder="Search..."
                      className={style["serach-input"]}
                    />
                    <button
                      style={{ margin: 0 }}
                      className={style["search-btn"]}
                      onClick={handleSearchSubmit}
                    >
                      <Icon style={{ fontSize: "20px" }} icon="mdi:magnify" />
                    </button>
                  </div>
                  <Icon
                    style={{
                      fontSize: "28px ",
                      color: "#0077d4",
                      cursor: "pointer",
                    }}
                    icon="bx:export"
                  />
                  <button
                    // style={{ width: "30%" }}
                    className={style["custom-btn"]}
                  >
                    <Icon
                      style={{ fontSize: "24px " }}
                      icon="ic:outline-print"
                    />
                    Print
                  </button>
                  <button
                    //  onClick={handlenew}
                    onClick={() => {
                      navigate("/add_sku_new");
                    }}
                    style={{ margin: 0 }}
                    className={style["custom-btn"]}
                  >
                    New
                    <Icon icon="mdi:plus" width="24" height="24" />
                  </button>
                </div>
              </div>
              <CustomerTable
                columns={SkuListColumn}
                allCategories={skuList?.length ? skuList : []}
                handleEditData={(product) =>{
                  console.log(product)
                  navigate(`/edit_sku_new/${product?.Id}`)
                }
                }
                searchInput={searchInput}
                setSearchInput={setSearchInput}
              />
              <table></table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkuListNew;
